/* Copyright (c) Trimble Inc. All rights reserved. */

/**
 * Authentication Library
 *
 * Main entry point for the authentication library.
 * Provides AuthProvider component and utilities for authentication workflows.
 */

// Main component exports
export { AuthChecker } from './components/auth-checker/index.component';
export { TokenExchanger } from './components/token-exchanger/index.component';
export { UserAvatar } from './components/user-avatar/index.component';
export { AuthProvider } from './components/auth-provider/AuthProvider.component';
export type { AuthConfig, Environment } from './models/AuthConfig.model';

export { UserPanel } from './components/user-panel/index.component';
export { initializeAuthDb } from './tables/initializeDb';

export { useTokenStore } from './stores/Token.store';
export { JWTParseHelper } from './helpers/JWTParser.helper';

export { useNavbarMenuCollapseStore } from './stores/NavbarMenuCollapse.store';
export * from './clients/SecureHttpClient.util';
export { SecureHttpClient } from './clients/SecureHttpClient.util';
export { withAuthGuard } from './hoc/auth-guard/AuthGuard.hoc';
export { useUserDetails } from './hooks/UserDetails.hook';
export { getUserProfile } from './stores/User.store';
export { dropAuthDatabase } from './tables/Auth.db';

export { SessionExpiryDialog } from './components/session-expiry-dialog/index.component';
export { useSessionExpiryMonitor } from './hooks/useSessionExpiryMonitor.hook';
export { OAUTH_CALLBACK_PARAMS } from './config/CONSTANTS';
export { AuthRedrectionHelper, AuthRedirectionHelper } from './helpers/AuthRedirector.helper';
